var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"MainContent"},[_c('h1',[_vm._v("Я "+_vm._s(_vm.message)+" страница")])])])}
var staticRenderFns = []

export { render, staticRenderFns }